import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { TextToolTip } from 'components';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { dashboardActions } from 'store';
import { FindLoad, renderFirstLetters, User } from 'utils';
import { Svg } from 'assets';

const ACTION_TYPE = 'GET_DASHBOARD_ASSIGNED_CLIENTS';

export const AssignedClients = ({ item, handleDeleteWidget }) => {
    const { assignedClients } = useSelector((state) => ({
        assignedClients: state.dashboard.assignedClients,
    }));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loader = FindLoad(ACTION_TYPE);
    const { userInfo } = User();

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    const handleViewAll = () => {
        window.open(`/staff/${userInfo?.id}?activeTab=Assigned%20Clients`, '_blank', 'noopener,noreferrer');
    };

    const goToClient = (clientId) => {
        if (clientId) navigate(`/client/${clientId}`);
    };

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell
            iconId={5}
            onClose={handleDeleteWidget}
            onOpen={assignedClients?.length ? handleViewAll : undefined}
        >
            <div className="main-dashboard-client-overview-card-wrapper">
                {assignedClients?.length ? (
                    <>
                        <h1 className="client-overview-card-total">{assignedClients.length}</h1>
                        <p className="assigned-clients-subtitle">Clients under your care</p>

                        <div className="assigned-clients-list">
                            {assignedClients.map((client) => {
                                const name = `${client?.clientCode ? `(${client.clientCode}) ` : ''}${client?.clientName || ''}`;
                                return (
                                    <button
                                        type="button"
                                        key={client.clientId}
                                        className="assigned-clients-row"
                                        onClick={() => goToClient(client.clientId)}
                                    >
                                        <span className="assigned-clients-row__avatar">
                                            {client?.avatar?.url ? <img src={client.avatar.url} alt="avatar" /> : renderFirstLetters(client)}
                                        </span>

                                        <TextToolTip
                                            classNameWrapper={'assigned-clients-row__name-wrap'}
                                            classNameText={'assigned-clients-row__name'}
                                            text={name}
                                            content={name}
                                        />

                                        <Svg.ChevronRightSvg className="assigned-clients-row__chevron" />
                                    </button>
                                );
                            })}
                        </div>
                    </>
                ) : (
                    <EmptyStateDashboard iconId={5} title="No assigned clients" description={'Once clients are assigned, they will appear here'} />
                )}
            </div>
        </DashboardWidgetShell>
    );
};
